module.exports = __webpack_public_path__ + "static/media/wave-academy-mobile.7355e039.svg";